export const formatBlogDate = (iso) => {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return date
    .toLocaleDateString("en-GB", { day: "2-digit", month: "long" })
    .replace(/^0/, "");
};
